import { NextPage }         from 'next';
import AppHead              from '@core/components/common/AppHead';
import AppLayout            from '@layouts/AppLayout';
import { ContactUsLanding } from '@features/auth/contact-us/containers/ContactUsLanding';


const ContactUsPage: NextPage = () => {
    return (
        <ContactUsLanding/>
    );
};

// @ts-expect-error
ContactUsPage.getLayout = function getLayout(page: typeof ContactUsPage) {
    return (
        <>
            <AppHead
                title="Contact Us"
                description="Would you like to get in touch with us? Send us a message and let us know what we can do for you."/>

            <AppLayout requireAuth={false}>
                {/*// @ts-expect-error*/}
                {page}
            </AppLayout>
        </>
    );
};

export default ContactUsPage;
